module.exports = "/assets/data/6c9609052d32de6d07e7054452795605-CH43.data.json";